/**
 * "Required" for guest first/last names. Yup's `string().required()` only checks `length > 0`, so a
 * whitespace-only value (`" "`) passes and, because every submit path trims before writing, reaches the
 * backend as `""` — the nameless contacts seen across prod guest lists (LGL-50, LGL-63). Trim first so a
 * blank value fails the same way an empty one does; surrounding whitespace on a real name is still fine.
 */
export const isNonBlankName = (value: string | undefined): boolean => !!value?.trim();
